<template>
  <v-container>
    <v-row class="justify-space-between">
      <div class="text text-h4 titulo">
        <v-icon class="mr-2">fas fa-file-import</v-icon>
        Importar Productos
      </div>
      <v-btn text @click="$router.push({name:'Products'})" class="ml-2" ><v-icon>fas fa-chevron-left</v-icon></v-btn>  
    </v-row>
    <v-row justify="center" class="mt-6">
      <v-col cols="12" class="text-center">
        <v-stepper
              v-model="e6"
              vertical
          >
          <v-stepper-step
            :complete="e6 > 1"
            step="1"
            color="info"
          >
            Descargue la Muestra
            <small>Descarga el archivo de muestra CSV</small>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-card
              class="mb-12"
              height="100px"
              flat
            >
              <v-row class="justify-center align-center" style="height: 100%">
                <v-btn href="https://runflow-evo-bucket.s3.us-east-2.amazonaws.com/files/correcto_products_import.csv"><v-icon class="mr-2">fas fa-download</v-icon> Descargar</v-btn>
              </v-row>
            </v-card>
            <v-btn
              color="success"
              @click="e6 = 2"
            >
              Continuar
            </v-btn>
            <v-btn text >
              Atrás
            </v-btn>
          </v-stepper-content>

          <v-stepper-step
            :complete="e6 > 2"
            step="2"
            color="info"
          >
            Seleccione el archivo
            <small>Seleccione el archivo CSV con los datos a importar</small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-card
              color=""
              class="mb-12"
              flat
            >
              <v-row class="justify-center align-center" style="height: 100%">
                  <v-file-input
                  class="pa-10"
                  style="max-width:500px"
                  v-model=file
                  accept = '.csv'
                  prepend-icon="fas fa-cloud-upload-alt"
                  outlined
                  show-size
                  hint="Selecciona el archivo CSV a importar"
                  persistent-hint
                ></v-file-input>
              </v-row>
              <v-row justify="space-between">
                <v-col>
                  <v-card>
                    <v-card-title>Familias [family]</v-card-title>
                    <v-card-subtitle>Ingrese el ID correspondiente</v-card-subtitle>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Nombre</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="family in families" :key="family.id">
                          <td><strong>{{family.id}}</strong></td>
                          <td class="d-flex justify-start align-center">{{family.name}}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card>
                    <v-card-title>Lineas [line]</v-card-title>
                    <v-card-subtitle>Ingrese el ID correspondiente</v-card-subtitle>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Nombre</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="line in lines" :key="line.id">
                          <td><strong>{{line.id}}</strong></td>
                          <td class="d-flex justify-start align-center">{{line.name}}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
                 <v-col>
                  <v-card>
                    <v-card-title>Venta por [sell_unit_m2]</v-card-title>
                    <v-card-subtitle>Ingrese el ID correspondiente</v-card-subtitle>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Valor</th>
                          <th>Nombre</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><strong>0</strong></td>
                          <td class="d-flex justify-start align-center">Precio por Unidad</td>
                        </tr>
                        <tr>
                          <td><strong>1</strong></td>
                          <td class="d-flex justify-start align-center">Precio por Metro<sup>2</sup></td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
                
              </v-row>
            </v-card>
            <v-btn :disabled="file==''" color="success" @click="onFileChange" :loading="loading">
              <v-icon class="mr-2">fas fa-file-upload</v-icon>Subir Archivo
            </v-btn>
            <v-btn text @click="e6=1">
              Atrás
            </v-btn>
          </v-stepper-content>
          <v-stepper-step
            :complete="e6 > 3"
            step="3"
            color="info"
            :rules="[() => errorSupplies.length>0?false:true]"
          >
            Resultados
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-card
              color=""
              class="mb-12"
              min-height="100px" 
              flat
            >
              <v-row class="justify-center" v-if="errorSupplies.length>0 && newSupplies.length>0">
                <v-col class="text-center" cols="8">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th>
                          Item
                        </th>
                        <th>
                          CODIGO (SKU)
                        </th>
                        <th>
                          Nombre
                        </th>
                        <th>
                          Error
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in errorSupplies" :key="item.item">
                        <td>
                          {{item.item}}
                        </td>
                        <td>
                          {{item.sku}}
                        </td>
                        <td>
                          {{item.name}}
                        </td>
                        <td>
                          {{item.message}}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
              
              <v-row  v-else-if="newSupplies.length>0" class="justify-center align-center" style="height: 100%">
                <div class="text text-h6">
                  Se verificaron <strong>{{newSupplies.length}}</strong> registros correctamente
                </div>
              </v-row>
              
            </v-card>
            <v-btn
              color="success"
              @click="upload"
              :disabled="errorSupplies.length>0 && newSupplies.length>0"
              :loading="loading"
            >
              <v-icon class="mr-2">fas fa-sd-card</v-icon>
              Guardar
            </v-btn>
            <v-btn text @click="e6=2">
              Atrás
            </v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>
    <!-- Dialogo para mostrar el progreso de la carga -->
    <v-dialog 
    v-model="showProgress"
    persistent
    max-width="500"
    >
      <v-card class="pa-10"> 
        <v-card-title class="titulo text-h4">Registrando...</v-card-title>
        <v-row>
          <v-col>
            <v-progress-linear v-model="progress" />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col class="text-center">
            <h1 class="text text-h4 titulo">{{progress | number('0.0')}}%</h1>
            <h1 v-if="uploadingError"  class="text text-h6 titulo error--text mt-4">{{uploadingErrorMessage}}</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="progress>=100 && !uploadingError">
            <h1 class="text text-h6 titulo text-center" v-if="!uploadingError">Artículos Cargados Correctamente</h1>
            <div class="text-center">
            <v-btn class="mt-4" color="success" @click="$router.push({name:'Products'})">Cerrar</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import notifications from '@/utils/notifications'
import {fetchFamily, fetchLines, fetchProducts, createProduct} from '@/api/products'
import axios from 'axios'
export default {
  name:'ImportProducts',
  data() {
    return {
      file: '',
      newSupplies:[],
      errorSupplies:[],
      products:[],
      families:[],
      lines:[],
      keys:[
        'sku',
        'name',
        'price',
        'sell_unit_m2',
        'width',
        'height',
        'family',
        'line',
        'customer'
        ],
      loading:false,
      progress:0,
      showProgress:false,
      uploadingError:false,
      uploadingErrorMessage:'',
      e6:1,
    }
  },
  async created(){
    
    this.families=this.$store.getters.getFamilies
    this.lines=this.$store.getters.getLines
    //sort = '', search = '', page = '', page_size = '', customer = '', family = '', line = '', status = ''
    await fetchProducts('','',1,-1,'','','','')
      .then((data)=>{
        this.products = data.results
      })
      .catch((err)=>{
        notifications.showError('Error cargando productos '+err)
      })
  },
  methods:{
    onFileChange(){
      const config={
        header: true,
        complete: (results) =>{
          this.verifyData(results)
        },
        skipEmptyLines: true
      }
     this.$papa.parse(this.file, config)
    },
    async upload(){
      this.loading=true
      var progressStep=this.newSupplies.length!=0?(100/this.newSupplies.length):100
      this.showProgress=true
      
      for(let i=0;i<this.newSupplies.length;i++){
        const item=this.newSupplies[i]
        try {
        //1. Se Crea el artículo
        const articleData={
          name:item.name,
          sku:item.sku,
          width:item.width,
          height:item.height,
          price:item.price,
          family:item.family,
          line:item.line,
          status:true,
          sell_unit_m2:item.sell_unit_m2,
          receta:[],
          supplies:[]
        }
        //Rev para Grafikpro 
        if(item.customer>0){
          articleData.customer=item.customer
        }
        await createProduct(articleData)
        .then(async res=>{
          this.progress+=progressStep 
        })
        .catch(e=>{
          throw e
        })
        }
        catch(error) {
          this.uploadingError=true
          this.loading=false
          this.uploadingErrorMessage='Error Cargando item: '+this.newSupplies.indexOf(item)+ ' '+item.sku+' '+item.name
          break
        }
      }
      this.loading=false
    },
    async verifyData(data){
      this.loading=true
      console.log(data)
      this.newSupplies=[]
      this.errorSupplies=[]
      this.header=[]
      
      //Verifica que la cantidad de campos sea correcta
      console.log(data.meta.fields.length)
      //Incluimos el campo clientes ---- REV para Grafikpro
      // se aumenta un campo si el campo clientes es 0 no se incluye 
      // el cliente en la creación del producto
      if(data.meta.fields.length!=9){
        notifications.showError('Error en cantidad de campos')
        this.loading=false
        return 0
      }
      
      //Validación de Datos
      data.data.map((item)=>{
        let error = false
        let message=''
        let foundFamily=false
        let foundLine=false

        //Valida que el resto de los campos no estén vaciós
        // y que existan todas las claves necesarias
        Object.keys(item).map(key=>{
          if(item[key].length==0){
            error=true
            message=`Campo ${key} vacío`
          }
          if (!this.keys.includes(key)){
            error = true
            message=`Nombre de campo <${key}> inválido`
          }
        })

        //Quitar los espacios del campo SKU
        //str = str.replace(/\s+/g, '');
        item.sku=item.sku.replace(/\s+/g, '')
        item.sku=item.sku.toUpperCase() //Lleva a mayusculas

        //Convierte los campos alert en boleanos
        item.sell_unit_m2=item.sell_unit_m2=='0'?false:true

        //Convierte campos critic, qty, price en flotante
        item.price=parseFloat(item.price)

        //Valida que no haya un SKU duplicado
        if (this.newSupplies.find(newItem=>newItem.sku.toLowerCase() == item.sku.toLowerCase())){
          error = true
          message='SKU Duplicado'
        }
        
        //Valida que el familia existe
        if (!this.families.find(family=>family.id == item.family)){
            error = true
            message='Familia no existe'
        }
        
        //Valida que la línea existe
        if (!this.lines.find(line=>line.id == item.line)){
            error = true
            message='Linea no existe'
        }

        //Valida que el campo precio es un número mayor que cero
        if(isNaN(item.price)||parseInt(item.price)<0){
          error=true
          message='El campo <price> no es un número o es inválido'
        }

        //Valida que el campo ancho es un número mayor que cero
        if(isNaN(item.width)||parseInt(item.width)<0){
          error=true
          message='El campo <width> no es un número o es inválido'
        }

        //Valida que el campo precio es un número mayor que cero
        if(isNaN(item.height)||parseInt(item.height)<0){
          error=true
          message='El campo <heigth> no es un número o es inválido'
        }

        if(error==true){
          this.errorSupplies.push({
            item: data.data.indexOf(item)+1,
            sku:item.sku,
            name:item.name,
            message:message
          })
        }
        item.error = error
        this.newSupplies.push(item)
      })
      this.e6=3
      this.loading=false
    }
  }
}
</script>

<style lang="scss">
.v-stepper{
  box-shadow: 0  !important;
}
.v-stepper__content{
  margin: -8px -36px -16px 42px !important;
}
.v-stepper__step__step{
  height: 40px !important;
  width: 40px !important;
  font-size: 1rem !important;
}

</style>